/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Green_AcresInputs */

const cs_enum_green_acres = /** @type {(inputs: Enum_Green_AcresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green-Acres`)
};

const en_enum_green_acres = /** @type {(inputs: Enum_Green_AcresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green-Acres`)
};

/**
* | output |
* | --- |
* | "Green-Acres" |
*
* @param {Enum_Green_AcresInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_green_acres = /** @type {((inputs?: Enum_Green_AcresInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Green_AcresInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_green_acres(inputs)
	return cs_enum_green_acres(inputs)
});